import { ListItemButton, ListItemText, ListItemIcon, Menu, MenuItem, Paper } from "@mui/material";
import LaunchIcon from "@mui/icons-material/Launch";
import React, { useContext, useMemo } from "react";
import { UploadFile } from "@mui/icons-material";
import { environment } from "../../config/environment";
import { useNavigate, useParams } from "react-router-dom";
import { ActionsList } from "../ActionsList/ActionsList";
import { convertAttachmentIdToRestId, getReadingAttachments } from "../../taskpane";
import { useStartInvoiceEmailExtraction } from "../../hooks/useStartInvoiceEmailExtraction";
import { useEmailId } from "../../hooks/useEmailId";
import { ToastContext } from "../../context/ToastContext";
import { useCurrentMailbox } from "../../hooks/useCurrentMailbox";

const InvoicesActions = () => {
  const emailId = useEmailId();
  const { supplierId } = useParams();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const attachments = useMemo(() => getReadingAttachments() ?? [], []);
  const { startInvoiceEmailExtraction } = useStartInvoiceEmailExtraction();
  const { showToast } = useContext(ToastContext);
  const { currentEmailAddress } = useCurrentMailbox();

  const handleAddToTasks = () => {
    window.open(`${environment.webAppUrl}/actions/invoices-upload?mode=add`, "_blank");
  };

  const handleQuickAddInvoice = async (invoiceId: string, attachmentName: string) => {
    if (!emailId) {
      showToast("Failed to start invoice email extraction, the email was not found", "error");
      return;
    }

    const restId = convertAttachmentIdToRestId(invoiceId);

    const response = await startInvoiceEmailExtraction({
      emailId: emailId,
      mailbox: currentEmailAddress,
      attachmentIds: [restId],
    });

    if (response) {
      navigate(`/payables/${supplierId}/quick-add/${encodeURIComponent(attachmentName)}/job/${response[0]}`);
    }
  };

  return (
    <>
      <Paper>
        <ActionsList>
          <ListItemButton onClick={(e) => setAnchorEl(e.currentTarget)} component="li">
            <ListItemIcon sx={{ minWidth: "auto", marginRight: 1 }}>
              <UploadFile sx={{ fontSize: 20 }} />
            </ListItemIcon>
            <ListItemText primary="New Invoice: Quick Add" />
          </ListItemButton>
          <ListItemButton onClick={handleAddToTasks} component="li">
            <ListItemIcon sx={{ minWidth: "auto", marginRight: 1 }}>
              <LaunchIcon sx={{ fontSize: 20 }} />
            </ListItemIcon>
            <ListItemText primary="New Invoice: Add to Tasks" />
          </ListItemButton>
        </ActionsList>
      </Paper>
      <Menu open={open} onClose={() => setAnchorEl(null)} anchorEl={anchorEl}>
        {attachments.map((attachment) => (
          <MenuItem key={attachment.id} onClick={() => handleQuickAddInvoice(attachment.id, attachment.name ?? "")}>
            {attachment.name}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default InvoicesActions;
